import moment from 'moment'
const SysUtils = {
  debug (obj) {
    console.log(this.name + ':' + JSON.stringify(obj))
  },
  copyObjectValue (target, source) {
    $.extend(true, target, source)
    return target
  },
  cloneObject (source) {
    let target
    if (source instanceof Array) {
      target = []
      $.extend(true, target, source)
    } else if (source instanceof Object) {
      target = {}
      $.extend(true, target, source)
    } else {
      target = source
    }
    return target
  },
  convStringToRangeDate: (rangeStr) => {
    if (SysUtils.isEmpty(rangeStr)) {
      return null
    }
    let arr = rangeStr.match(/(\d{4}\/\d{2}\/\d{2})(\s-\s)(\d{4}\/\d{2}\/\d{2})$/)
    if (arr === null || arr.length !== 4) {
      return null
    }
    return {startDate: arr[1], endDate: arr[3]}
  },
  convRangeDateString: (rangeObj) => {
    if (!rangeObj) {
      return ''
    } else {
      return moment(rangeObj.startDate).format('YYYY/MM/DD') + ' - ' + moment(rangeObj.endDate).format('YYYY/MM/DD')
    }
  },
  getRandnum () {
    return Math.floor(Math.random() * 9999)
  },
  formatDate: (value, format) => {
    return moment(value, 'YYYY/MM/DD').format(format)
  },
  checkDateFormat (value, format) {
    return (moment(value, format).format(format) === value)
  },
  convSelectArrToMap: (selectArr) => {
    var map = {}
    selectArr.forEach(function (obj1) {
      if ('children' in obj1) {
        obj1.children.forEach(function (obj2) {
          map[obj2.id] = obj2.text
        })
      } else {
        map[obj1.id] = obj1.text
      }
    })
    return map
  },
  getDate (addDay) {
    return moment().add(addDay, 'days').format('YYYY/MM/DD')
  },
  convDbArrToSelectArr: function (dbArr, idCol, valCol, grpCol) {
    let labelFunc = function (obj) {
      return obj[valCol]
    }
    if ((typeof valCol) === 'function') {
      labelFunc = valCol
    }

    if (grpCol !== undefined) {
      let selMap = {}
      dbArr.forEach(function (obj) {
        if (!(obj[grpCol] in selMap)) {
          selMap[obj[grpCol]] = {text: obj[grpCol],
            children: []
          }
        }
        selMap[obj[grpCol]].children.push({id: obj[idCol], text: labelFunc(obj), grp: obj[grpCol]})
      })
      return $.map(selMap, function (value, index) { return value })
    } else {
      let selArr = []
      dbArr.forEach(function (obj) {
        selArr.push({id: obj[idCol], text: labelFunc(obj)})
      })
      return selArr
    }
  },
  createHideString: function (ch, length) {
    let label = ''
    for (let i = 0; i < length; i++) {
      label = label + ch
    }
    return label
  },
  existsKey (arr, key) {
    if (arr) {
      return (key in arr)
    } else {
      return false
    }
  },
  isEmpty: function (value) {
    if (value === undefined || value === null || value === '') {
      return (true)
    }
    if (value instanceof Array) {
      return (value.length === 0)
    }
    if (value instanceof Object) {
      return (Object.keys(value).length === 0)
    }
  },
  createTableConfig (config) {
    let listFields = []
    Object.keys(config.fields).forEach(function (key) {
      let val = config.fields[key]
      val.data = key
      if (val.listView) {
        listFields.push(val)
      }
    })
    config.listFields = listFields
    return config
  },
  objectEquals (a, b) {
    if (a === b) {
      return true
    }
    return JSON.stringify(a) === JSON.stringify(b)
  },
  hexToRgb (hex) {
    let r = 0; let g = 0; let b = 0
    if (hex.length === 4) {
      r = '0x' + hex[1] + hex[1]
      g = '0x' + hex[2] + hex[2]
      b = '0x' + hex[3] + hex[3]
    } else if (hex.length === 7) {
      r = '0x' + hex[1] + hex[2]
      g = '0x' + hex[3] + hex[4]
      b = '0x' + hex[5] + hex[6]
    }

    return [r, g, b]
  },
  hexToHsl (hex) {
    let rgb = this.hexToRgb(hex)

    let r = rgb[0] / 255
    let g = rgb[1] / 255
    let b = rgb[2] / 255
    let cmin = Math.min(r, g, b)
    let cmax = Math.max(r, g, b)
    let delta = cmax - cmin
    let h = 0
    let s = 0
    let l = 0

    if (delta === 0) { h = 0 } else if (cmax === r) { h = ((g - b) / delta) % 6 } else if (cmax === g) { h = (b - r) / delta + 2 } else { h = (r - g) / delta + 4 }

    h = Math.round(h * 60)

    if (h < 0) { h += 360 }

    l = (cmax + cmin) / 2
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1))
    s = +(s * 100).toFixed(1)
    l = +(l * 100).toFixed(1)

    return [h, s, l]
  },
  textContrast (backgroundHex) {
    let hsl = this.hexToHsl(backgroundHex)

    hsl[0] = (hsl[0] / 360 + 0.5) % 1 // Hue
    hsl[1] = (hsl[1] / 100 + 0.5) % 1 // Saturation
    hsl[2] = (hsl[2] / 100 + 0.5) % 1 // Luminocity

    return [(hsl[0] * 360), (hsl[1] * 100), (hsl[2] * 100)]
  }
}
export default SysUtils
